import { DataContainer, submitEvent, submitMerge } from "@otto-ec/tracking-bct";
import {
  capitalizeAndPrefixKeys,
  isNotEmptyObject,
  isToggleActive,
  RawRumData,
  transformObject,
} from "../utils/util";
import { trackingEventArray, trackingPIArray } from "../config/filter-list";

/**
 *
 *
 *
 *
 */
export function trackingEndpointLogic(
  rumData: RawRumData
): void {
  const AddPIMetricList: RawRumData = filterFor(rumData, trackingPIArray);
  const AddEventMetricList: RawRumData = filterFor(rumData, trackingEventArray);

  if (isNotEmptyObject(AddPIMetricList)) {
    trackingAddMergeToPageImpression(capitalizeAndPrefixKeys(AddPIMetricList));
  }

  if (isNotEmptyObject(AddEventMetricList)) {
    trackingAddEvent(capitalizeAndPrefixKeys(AddEventMetricList));
  }
}

const submitMergeOnLateDefault = "bs_submit_merge_on_late_default";

/**
 *
 *
 *
 *
 */
export function trackingAddMergeToPageImpression(
  metricData: RawRumData,
): void {
  if (isNotEmptyObject(metricData)) {
    const strategy: "default" | "discard" = isToggleActive(
      submitMergeOnLateDefault,
    )
      ? "default"
      : "discard";

    submitMerge(convertToDataContainer(metricData), [], strategy);
  }
}

/**
 *
 *
 *
 *
 */
export function trackingAddEvent(
  metricData: RawRumData,
): void {
  if (isNotEmptyObject(metricData)) {
    submitEvent(convertToDataContainer(metricData));
  }
}

/**
 *
 *
 */
const convertToDataContainer = (
  metricData: RawRumData,
): DataContainer =>
  transformObject(metricData, (entries) =>
    entries.map(([key, value]) => [key, [value.toString()]] as const),
  );

/**
 *
 *
 *
 *
 */
const filterFor = (metricData: RawRumData, filterList: string[]): RawRumData =>
  transformObject(metricData, (entries) =>
    entries.filter(([k]) => filterList.includes(k)),
  );
